import { render, staticRenderFns } from "./admin-managefile.vue?vue&type=template&id=36d13f79&"
import script from "./admin-managefile.vue?vue&type=script&lang=js&"
export * from "./admin-managefile.vue?vue&type=script&lang=js&"
import style0 from "./admin-managefile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports